import { requestSuccess } from "@Api";
import { UPDATE_USER } from "@Actions/types";
import store from "@Redux";

const userUpdated = (data) => {
	return (dispatch) => {
		const companyId = store.getState().company?.companyId || 0;
		if (companyId === data.companyId || companyId === 0) {
			dispatch(requestSuccess(UPDATE_USER, data));
		}
	};
};

export default userUpdated;
